"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    width: _propTypes.default.number,
    trigger: _propTypes.default.string,
    position: _propTypes.default.string,
    content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    header: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    open: _propTypes.default.bool,
    zIndex: _propTypes.default.number,
    background: _propTypes.default.string,
    borderRadius: _propTypes.default.string,
    left: _propTypes.default.string,
    marginLeft: _propTypes.default.string,
    top: _propTypes.default.string,
    bottom: _propTypes.default.string,
    asToolTip: _propTypes.default.bool,
    right: _propTypes.default.string,
    rightArrow: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    width: 200,
    position: 'right',
    content: '',
    trigger: 'hover',
    zIndex: 109,
    asToolTip: false
  }
};
exports.default = _default;